import React from "react";
import dayjs from "dayjs";

import {
  Box,
  Button,
  Card,
  Column,
  Columns,
  Divider,
  Heading,
  Link,
  Text,
  VStack,
  Wrapper,
} from "components";

const NewsItem = ({ data }) => (
  <Card>
    <VStack space={{ _: "layout.1", md: "layout.2", lg: "layout.3" }}>
      <Divider />
      <Text children={data.title.text} size={600} clamp={4}>
        <Link children={data.title.text} href={data.link.url} />
      </Text>
      <Text children={data.date} size={600} color="brand.secondary" ellipsis />
    </VStack>
  </Card>
);

const NewsYear = ({ year, items }) => {
  return (
    <>
      {/* Year */}
      <Box id={year}>
        <Heading children={year} size={600} color="label.0" />
      </Box>

      <Columns spaceX="layout.3" spaceY="layout.3">
        <Column width={{ _: 1 / 1, md: 4 / 12 }} />
        <Column width={{ _: 1 / 1, md: 8 / 12 }}>
          <Columns spaceX="layout.3" spaceY="layout.3">
            {items.map((items, index) => (
              <Column
                width={{ _: 1 / 1, md: 1, lg: 1 / 2, xlg: 1 / 2 }}
                key={"newsItem" + index}
              >
                <NewsItem {...items} />
              </Column>
            ))}
          </Columns>
        </Column>
      </Columns>
    </>
  );
};

export function NewsFeed({ title, items, recent_only }) {
  const sortedItems = [];

  if (!recent_only) {
    // Add all existing years as objects to sortedItems array.
    items.forEach((node) => {
      // Check if this item's year exists in the sortedItems array
      let year = dayjs(node.data.date).format("YYYY");
      let yearExists = false;
      sortedItems.forEach((item) => {
        if (item.year === year) {
          yearExists = true;
        }
      });
      // If yearExists == false, add an object with this year to the array
      if (yearExists === false) {
        sortedItems.push({ year: year, items: [] });
      }
    });

    // Add nodes to their proper place in the sortedItems array
    items.forEach((node) => {
      let year = dayjs(node.data.date).format("YYYY");
      sortedItems.forEach((item) => {
        if (item.year === year) {
          item.items.push(node);
        }
      });
    });
  }

  return (
    <Wrapper py={{ _: "layout.5", md: "layout.6" }} id={title && title.text}>
      <VStack space={{ _: "layout.4", md: "layout.6" }}>
        {recent_only && title && title.text && (
          <Heading children={title.text} size={700} />
        )}
        {recent_only && (
          <VStack space="layout.3">
            <Columns spaceX="layout.5" spaceY="layout.4">
              {items.slice(0, 3).map((item, i) => {
                return (
                  <Column
                    width={{ _: 1 / 1, lg: 4 / 12 }}
                    key={`newsItem-${i}`}
                  >
                    <NewsItem {...item} />
                  </Column>
                );
              })}
            </Columns>
          </VStack>
        )}
        {recent_only && (
          <Link href="/news/">
            <Button
              children="View all"
              appearance="primary"
              intent="primary"
              round={true}
            />
          </Link>
        )}
        {/* Draw full set of News Years */}
        {!recent_only &&
          sortedItems.map((item, index) => (
            <NewsYear {...item} key={"newsYear" + index} />
          ))}
      </VStack>
    </Wrapper>
  );
}
